import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import {
    Grid,
    GridCell,
    Select,
    TextInput,
    Icon,
    css,
    Button,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue,
} from "app/reducers/form";

import {isMultiSelectCloseOnChange} from "./filters";
import {ReduxList} from "app/types/app-types";
import {AvailableOptionsType} from "../types";
import {FiltersFormType, ElementsFilterType} from "../types/filtertypes";
import {DarkGrayColor} from "app/helpers/colors";
import debounce from "lodash/debounce";
import { selectFormValues } from "app/reducers/form";

interface Props {
    availableOptions: ReduxList<AvailableOptionsType>
    filtersForm: FiltersFormType
    setIsDirty: Function
    updateInputValue: typeof updateInputValue
}

class ElementsFilters extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    handleFilterElements(index: number, field: string, value: string, secondValue: string = '') {
        const {filtersForm} = this.props

        const newitem : ElementsFilterType = {
            index: index,
            field: field,
            value: value,
            secondValue: secondValue,
        }

        let current = filtersForm.elements ?? []
        current[index] = newitem

        this.props.updateInputValue('filtersForm','elements', current)
        this.props.setIsDirty(true)
    }

    handleRemoveFilterElements = (index: number) => {
        const {filtersForm} = this.props
        const current = [...filtersForm.elements]
        const newColumns = current.filter(element => element.index !== index);

        this.props.updateInputValue('filtersForm','elements', newColumns)
        this.props.setIsDirty(true)
    }

    handleAddFilterElements =  debounce(() => {
        const {filtersForm} = this.props
        const nextIndex = filtersForm.elements.length

        const newitem : ElementsFilterType = {
            index: nextIndex,
            field: '',
            value: '',
        }

        let current = [...filtersForm.elements]
        current[nextIndex] = newitem

        this.props.updateInputValue('filtersForm','elements', current)
        this.props.setIsDirty(true)
    }, 500)

    onSearch =  (phrase, option) => typeof option.name === "string" ? option.name.toLowerCase().includes(phrase.toLowerCase()) : true
    highlightTextGetter = item => typeof item.name === "string" ? item.name : "-"

    render() {
        const {availableOptions, filtersForm} = this.props

        const availableElements = availableOptions.data && availableOptions.data.available_elements && Array.isArray(availableOptions.data.available_elements) && availableOptions.data.available_elements.length > 0 ?
            availableOptions.data.available_elements.map((o: string) => {
                return {
                    label: `${o}`,
                    value: `${o}`
                }
            }) : null

        const availableColumns = availableOptions.data && availableOptions.data.product_columns ? availableOptions.data.product_columns.map((o: string) => {
            return {
                label: trans(`element_${o}`),
                value: `${o}`
            }
        }) : null

        const renderElements = filtersForm && filtersForm.elements && filtersForm.elements.length > 0 ?  filtersForm.elements : [{index: 0, field: '', value: '', secondValue: ''}]

        const elementFilters = renderElements.map((filter) => {
            const isRange = (filter.field === 'price_vat')

            return <StyledGridCell key={filter.index} className={ filtersForm.elements && filtersForm.elements.length > 0 ? 'active-filter' : ''}>
                <div className={'filter-element'}>
                    <span className='remove' onClick={() => this.handleRemoveFilterElements(filter.index)}>
                        <Icon type={'close-light'} color={DarkGrayColor}/>
                    </span>

                    {availableColumns &&
                    <Select
                        options={availableColumns}
                        key={filter.index}
                        value={filter.field}
                        label={<Icon type="code" text={trans('filter_element')} />}
                        onChange={(evt) => this.handleFilterElements(filter.index, evt, filter.value)}
                        search={true}
                        closeOnChange={true}
                        closeOnBlur={true}
                        highlightTextGetter={this.highlightTextGetter}
                    />
                    }

                    {isRange ?
                        <Grid className={'two-columns'}>
                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={filter.value}
                                    step={10}
                                    placeholder={trans('filter_value_from')}
                                    onChange={(evt) => {
                                        this.handleFilterElements(filter.index, filter.field, evt, filter.secondValue)
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.handleFilterElements(filter.index, filter.field, null, filter.secondValue)
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>
                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={filter.secondValue}
                                    step={10}
                                    placeholder={trans('filter_value_to')}
                                    onChange={(evt) => {
                                        this.handleFilterElements(filter.index, filter.field, filter.value, evt)
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.handleFilterElements(filter.index, filter.field, filter.value, null)
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>
                        </Grid>
                        :
                        <TextInput
                            type="search"
                            key={'_' + filter.index}
                            placeholder={trans('filter_element_value')}
                            value={filter.value}
                            onChange={(evt) => {
                                this.handleFilterElements(filter.index, filter.field, evt)
                            }}
                        />
                    }
                </div>
            </StyledGridCell>
        })

        return(
            <>
                {availableElements &&
                <GridCell className={filtersForm.product?.check_elements_availability && Array.isArray(filtersForm.product.check_elements_availability) && filtersForm.product.check_elements_availability.length > 0 ? 'active-filter' : ''}>
                    <Select
                        name={`filtersForm.product.check_elements_availability`}
                        multiple={true}
                        closeOnChange={isMultiSelectCloseOnChange}
                        options={availableElements}
                        label={<Icon type="code" text={trans('empty_elements')} />}
                        onChange={() => this.props.setIsDirty(true)}
                    />
                </GridCell>
                }


                {(filtersForm && filtersForm.elements && filtersForm.elements.length < 6 && availableColumns) &&
                elementFilters
                }

                <GridCell style={{alignSelf: 'center'}}>
                <Button
                    type={'void'}
                    secondary={true}
                    color={'#333'}
                    onClick={() => this.handleAddFilterElements()}
                    icon={<Icon type={'plus-light'} text={trans('filter_add')} />}
                />
                </GridCell>
            </>
        )
    }
}

const StyledGridCell = css(GridCell)({
    ' .muk-form-group': {
        marginBottom: '10px',
    },
    ' .m-textinput-wrapper': {
        marginRight: '10px',
    },
    ' .filter-element': {
        position: 'relative !important',
    },
    ' .range': {
        display: 'inline-flex',
    },
    ' .remove': {
        cursor: 'pointer',
        position: 'absolute !important',
        zIndex: 99,
        pointerEvents: 'auto',
        top: '-10px',
        right: '5px',
        borderRadius: '50%',
        background: '#fff',
        ' .muk-icon': {
            padding: '5px',
            ' .m-image path': {
                fill: '#bbb !important',
            },
        },
    },
    ' input': {
        lineHeight: '25px',
        marginRight: '5px',
    }
})

function mapStateToProps(state) {
    return {
        availableOptions: state.availableOptions,
        filtersForm: selectFormValues(state,'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(ElementsFilters)
